import { apiClient } from './apiClient';

export async function getAll(params = {}) {
  const response = await apiClient.get('/products', params);
  return response;
}

export async function getById(id) {
  const response = await apiClient.get(`/products/${id}`);
  return response.data || null;
}

export async function create(product) {
  const response = await apiClient.post('/products', product);
  return response.data;
}

export async function update(id, data) {
  const response = await apiClient.put(`/products/${id}`, data);
  return response.data;
}

export async function addStock(id, amount) {
  const response = await apiClient.post(`/products/${id}/stock`, { amount });
  return response.data;
}

export async function remove(id) {
  await apiClient.del(`/products/${id}`);
}

export async function totalStock() {
  const products = await getAll();
  const list = products.data || [];
  return list.reduce((sum, product) => sum + (Number(product.stock) || 0), 0);
}

export default { getAll, getById, create, update, addStock, remove, totalStock };
